import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/rent',
    component: Layout,
    redirect: '/rent/product',
    name: 'rent',
    meta: {title: '寄租商品', icon: 'order'},
    children: [
      {
        path: 'rentlist',
        name: 'rentlist',
        component: () => import('@/views/rent/product/rentlist'),
        meta: {title: '寄租列表',},
      },
      {
        path: 'rentDetail',
        name: 'rentDetail',
        component: () => import('@/views/rent/product/rentDetail'),
        meta: {title: '订单详情',},
        hidden:true
      },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单管理', icon: 'order'},
    children: [
      {
        path: 'orderlist',
        name: 'orderlist',
        component: () => import('@/views/oms/order/orderlist'),
        meta: {title: '租赁订单',}
      },
      {
        path: 'otherOrder',
        name: 'otherOrder',
        component: () => import('@/views/oms/order/otherOrder'),
        meta: {title: '逾期订单',}
      },
    ]
  },
  {
    path: '/cwxt',
    component: Layout,
    redirect: '/cwxt/finance',
    name: 'cwxt',
    meta: {title: '财务系统', icon: 'finance'},
    children: [
      {
        path: 'orderFeeDetails',
        name: 'orderFeeDetails',
        component: () => import('@/views/cwxt/finance/orderFeeDetails'),
        meta: {title: '订单费用明细',},
      },
      {
        path: 'shopFinance',
        name: 'shopFinance',
        component: () => import('@/views/cwxt/finance/shopFinance'),
        meta: {title: '店铺资金明细',},
      }
    ]
  },
  {
    path: '/yhlb',
    component: Layout,
    redirect: '/yhlb/userlist',
    name: 'yhlb',
    meta: {title: '用户管理', icon: 'user'},
    children: [
      {
        path: 'userlist',
        name: 'userlist',
        component: () => import('@/views/yhlb/userlist/index'),
        meta: {title: '用户列表',}
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/yhlb/userlist/admin'),
        meta: {title: '管理员列表',}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/yhlb/userlist/allocMenu'),
        meta: {title: '编辑管理员'},
        hidden: true
      },
      {
        path: 'addUser',
        name: 'addUser',
        component: () => import('@/views/yhlb/userlist/addUser'),
        meta: {title: '添加用户'},
        hidden: true
      },
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '系统设置', icon: 'ums'},
    children: [
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '设置选项',}
      },
      {
        path: 'contract',
        name: 'contract',
        component: () => import('@/views/ums/resource/contractList'),
        meta: {title: '合同列表',}
      },
      {
        path: 'contractDetail',
        name: 'contractDetail',
        component: () => import('@/views/ums/resource/contractDetail'),
        meta: {title: '合同详情',},
        hidden: true
      },
    ]
  },
  {
    path:'/shop',
    component:Layout,
    redirect:'/shop/storeList',
    name:'shop',
    meta:{title:'店铺',icon:'shop'},
    children:[
      {
        path:'storeList',
        name:'storeList',
        component: () => import('@/views/shop/storeList'),
        meta:{title:'店铺列表',}
      },
      {
        path:'addStore',
        name:'addStore',
        component: () => import('@/views/shop/addStore'),
        meta:{title:'添加店铺',},
        hidden: true
      },
      {
        path:'storeDetail',
        name:'storeDetail',
        component: () => import('@/views/shop/storeDetail'),
        meta:{title:'编辑店铺',},
        hidden: true
      }
    ]
  },
  {
    path:'/physical',
    component:Layout,
    redirect:'/physical/physicalList',
    name:'physical',
    meta:{title:'门店',icon:'physical'},
    children:[
      {
        path:'physicalList',
        name:'physicalList',
        component: () => import('@/views/physical/physicalList'),
        meta:{title:'门店列表',}
      },
    ]
  },
  {
    path: '/review',
    component: Layout,
    redirect: '/review/list',
    name: 'review',
    meta: {title: '用户评论', icon: 'comment'},
    children: [
      {
        path: 'comment',
        name: 'comment',
        component: () => import('@/views/review/list/index'),
        meta: {title: '评论列表',}
      },
      {
        path: 'reviewDetail',
        name: 'reviewDetail',
        component: () => import('@/views/review/list/detail'),
        meta: {title: '评论详情'},
        hidden:true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js